import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Spinner, Title } from "@yoast/ui-library";
import { prepareInternalRequest, doRequest } from "shared-frontend/functions/api";
import { hasAccessToken } from "shared-frontend/functions/auth";
import logo from "../images/my-yoast-academy-logo.svg";
import * as styles from "./WinbackRedirect.module.scss";

/**
 * Calls the winback API endpoint and redirects the user to the checkout URL.
 * Shown as a loading page while the request is in progress.
 *
 * @returns {JSX.Element} The WinbackRedirect component.
 */
const WinbackRedirect = () => {
	const { productReference } = useParams();
	const [ error, setError ] = useState( false );

	useEffect( () => {
		if ( ! hasAccessToken() ) {
			setError( true );
			return;
		}

		const request = prepareInternalRequest(
			`Subscriptions/special-offer/${ encodeURIComponent( productReference ) }`,
		);

		doRequest( request )
			.then( ( response ) => {
				window.location.replace( response.redirectTo );
			} )
			.catch( () => {
				setError( true );
			} );
	}, [ productReference ] );

	if ( error ) {
		return (
			<div className={ styles.layout }>
				<div className={ styles.card }>
					<img className={ styles.logo } src={ logo } alt="MyYoast" />
					<Title size="2">Something went wrong</Title>
					<p className={ styles.message }>
						We could not verify your session. Please log in and try again.
					</p>
				</div>
			</div>
		);
	}

	return (
		<div className={ styles.layout }>
			<div className={ styles.card }>
				<img className={ styles.logo } src={ logo } alt="MyYoast" />
				<Title size="2">Preparing your checkout...</Title>
				<p className={ styles.message }>You&apos;ll be redirected to the checkout page in a moment.</p>
				<div className={ styles.spinnerRow }>
					<Spinner />
				</div>
			</div>
		</div>
	);
};

export default WinbackRedirect;
